module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.11097/images/arrow-icon.png"